import React, { useEffect, useRef, useState } from "react";
import { FaInfoCircle, FaMapMarkerAlt, FaUserClock } from "react-icons/fa";

import {
  FIELD_APP_TIMEZONE_MODES,
  getTimezoneModeShortLabel,
} from "./fieldAppTimezoneDisplay";

import "./FieldAppTimezoneToggle.css";

export default function FieldAppTimezoneToggle({ mode, onModeChange, t }) {
  const [helpOpen, setHelpOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!helpOpen) return undefined;

    const handleDocumentClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setHelpOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, [helpOpen]);

  const viewerTz = getTimezoneModeShortLabel(FIELD_APP_TIMEZONE_MODES.VIEWER);
  const dataTz = getTimezoneModeShortLabel(FIELD_APP_TIMEZONE_MODES.DATA);

  return (
    <div className="field-app-timezone-toggle" ref={rootRef}>
      <span className="field-app-timezone-toggle-label">
        {t("Ver horários como")}:
      </span>
      <div
        className="field-app-timezone-toggle-buttons"
        role="group"
        aria-label={t("Fuso horário de exibição")}
      >
        <button
          type="button"
          className={`field-app-timezone-toggle-btn${
            mode === FIELD_APP_TIMEZONE_MODES.VIEWER ? " is-active" : ""
          }`}
          title={t("Seu horário — {{tz}}", {
            tz: viewerTz,
          })}
          aria-pressed={mode === FIELD_APP_TIMEZONE_MODES.VIEWER}
          onClick={() => onModeChange(FIELD_APP_TIMEZONE_MODES.VIEWER)}
        >
          <FaUserClock aria-hidden />
          <span>{t("Você")}</span>
        </button>
        <button
          type="button"
          className={`field-app-timezone-toggle-btn${
            mode === FIELD_APP_TIMEZONE_MODES.DATA ? " is-active" : ""
          }`}
          title={t("Horário da fazenda — {{tz}}", { tz: dataTz })}
          aria-pressed={mode === FIELD_APP_TIMEZONE_MODES.DATA}
          onClick={() => onModeChange(FIELD_APP_TIMEZONE_MODES.DATA)}
        >
          <FaMapMarkerAlt aria-hidden />
          <span>{t("Fazenda")}</span>
        </button>
      </div>
      <button
        type="button"
        className="field-app-timezone-toggle-info"
        aria-expanded={helpOpen}
        aria-label={t("Ajuda sobre horários")}
        onClick={() => setHelpOpen((open) => !open)}
      >
        <FaInfoCircle aria-hidden />
      </button>
      {helpOpen ? (
        <div
          className="field-app-timezone-toggle-help"
          role="dialog"
          aria-label={t("Ajuda — horários no rastreamento")}
        >
          <strong>{t("Qual relógio usar?")}</strong>
          <p>
            {t(
              "Cada ponto GPS tem uma hora. Aqui você escolhe em qual relógio essa hora aparece no mapa e no gráfico."
            )}
          </p>
          <ul>
            <li>
              <strong>{t("Você")}</strong> —{" "}
              {t("hora do seu computador ou celular ({{tz}}).", {
                tz: viewerTz,
              })}
            </li>
            <li>
              <strong>{t("Fazenda")}</strong> —{" "}
              {t("hora do campo, onde a máquina estava ({{tz}}).", {
                tz: dataTz,
              })}
            </li>
          </ul>
          <p>
            {t(
              "Exemplo: se você está nos EUA e a máquina trabalhou às 14h no Brasil, em «Você» pode aparecer outro horário; em «Fazenda» aparece 14h."
            )}
          </p>
          <p>
            {t(
              "Toque em um dos botões para trocar. Só o mapa e o gráfico mudam; listas e outros dados do app não."
            )}
          </p>
        </div>
      ) : null}
    </div>
  );
}
